import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AuditMessageModel } from '../../models/AuditMessageModel';
import { BaseApiService } from '../base-api.service';
import { UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root',
})
export class AuditService {
  baseUrl = window.location.origin;
  token = '';
  canEdit: boolean = false;
  constructor(
    private http: HttpClient,
    private baseAPIService: BaseApiService,
    public user: UserService,
  ) {
    this.user.token.subscribe(value => {
      this.token = value;
    });
    user.canEdit.subscribe(v => {
      this.canEdit = v;
    });
  }

  LogAuditMessage(logMsg: AuditMessageModel) {
    let url = this.baseUrl + '/api/Audit/LogAuditMessage';
    this.baseAPIService.headerToken = this.token;
    this.baseAPIService.putVoid<AuditMessageModel>(url, logMsg);
  }
}
